import type { ComponentProps } from "react";

import { SvgSlot } from "@/shared/ui/common";

export const PlusIcon = (props: ComponentProps<typeof SvgSlot>) => (
  <SvgSlot {...props}>
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        d="M13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4V11H3C2.44772 11 2 11.4477 2 12C2 12.5523 2.44772 13 3 13H11V21C11 21.5523 11.4477 22 12 22C12.5523 22 13 21.5523 13 21V13H21C21.5523 13 22 12.5523 22 12C22 11.4477 21.5523 11 21 11H13V4Z"
      />
    </svg>
  </SvgSlot>
);
